export default function Neighborhood() {
  return (
    <svg viewBox="0 0 640 660" aria-hidden="true" className="neighborhood-art">
      <rect width="640" height="660" fill="#e9e9dd" />
      <circle cx="476" cy="139" r="74" fill="#d4b986" />
      <path d="M0 450Q175 332 350 420T640 385V660H0Z" fill="#d2d6c3" />
      <path d="M0 545Q225 420 640 530V660H0Z" fill="#bbc5aa" />
      <path d="M67 316L301 154L539 316Z" fill="#384e43" />
      <path d="M101 312H503V555H101Z" fill="#faf5e9" />
      <path d="M301 154L539 316H503L301 178L101 316H67Z" fill="#263f35" />
      <path d="M339 310H503V555H339Z" fill="#e4d9c4" />
      <rect x="385" y="216" width="38" height="61" fill="#a97857" />
      <path d="M130 327H310V555H130Z" fill="#f1e8d7" />
      <rect x="153" y="351" width="62" height="82" fill="#718d84" />
      <rect x="238" y="351" width="49" height="82" fill="#718d84" />
      <path
        d="M184 351V433M153 393H215M262 351V433M238 393H287"
        stroke="#fff9ec"
        strokeWidth="6"
      />
      <rect x="377" y="354" width="75" height="104" fill="#718d84" />
      <path d="M414 354V458M377 406H452" stroke="#fff9ec" strokeWidth="7" />
      <path d="M236 555V470Q264 435 292 470V555" fill="#a97857" />
      <circle cx="279" cy="507" r="3" fill="#f5d797" />
      <path
        d="M230 555H302V568H220V579H312V590H210"
        stroke="#dbcfb8"
        strokeWidth="12"
      />
      <path d="M237 596L195 660H350L297 596Z" fill="#f6f0e1" />
      <path d="M39 490V293M569 534V342" stroke="#6a6952" strokeWidth="8" />
      <ellipse cx="41" cy="294" rx="59" ry="130" fill="#758269" />
      <ellipse cx="571" cy="363" rx="49" ry="100" fill="#567160" />
      <path d="M39 385V255M569 427V335" stroke="#53634e" strokeWidth="4" />
      <path
        d="M82 555Q105 495 130 555Q151 513 177 555M407 555Q432 504 451 555Q480 483 514 555"
        fill="#657b58"
      />
      <path d="M0 609H145M380 609H640" stroke="#9aaa90" strokeWidth="2" />
    </svg>
  );
}
